import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import TabOneAccordions from 'web/pages/private/CommonPages/Faq/TabOne'

import { Container, TabsWrapper , WebView, MobileView} from 'web/pages/private/CommonPages/Faq/FaqTabsStyled'

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Typography>{children}</Typography>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    'aria-controls': `vertical-tabpanel-${index}`,
  };
}

const FaqTabs = ({ sectionHeading, pageLanguageContents }) => {
  const [tabValue, setTabValue] = useState(0);

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <Container>
      <WebView>
        <Tabs
          orientation="vertical"
          variant="scrollable"
          value={tabValue}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: 'divider' }}
        >
          {sectionHeading.map((val, index) => {
            return (
              <Tab label={val} {...a11yProps(index)} />
            )
          })}
        </Tabs>
      </WebView>
      <MobileView>
        <Tabs
          variant="scrollable"
          value={tabValue}
          onChange={handleChange}
          aria-label="Vertical tabs example"
          sx={{ borderRight: 1, borderColor: 'divider' }}
        >
          {sectionHeading.map((val, index) => {
            return (
              <Tab label={val} {...a11yProps(index)} />
            )
          })}
        </Tabs>
      </MobileView>

      <TabsWrapper>
        {sectionHeading.map((val, index) => {
          let tabContents = Object.values(pageLanguageContents[val])
          return (
            <TabPanel value={tabValue} index={index}>
              <TabOneAccordions tabContents={tabContents} />
            </TabPanel>
          )
        })}
      </TabsWrapper>
    </Container>
  );
}

export default FaqTabs;